import axios from 'axios';
import * as H1 from '../Helper/H1';
import base64 from 'base-64'
import utf8 from 'utf8'


//  let encoded = base64.encode('YOUR_DECODED_STRING');
//  let decoded = base64.decode('WU9VUl9ERUNPREVEX1NUUklORw==');
// console.log(encoded,decoded);
let api;
export default async function Send(url,data = {},loader = null) {


data ={

  data:base64.encode( utf8.encode(JSON.stringify(data)) )

} 


if(loader){
  H1.notfy_dismiss()
  H1.notfy_loading()
}



  if(H1.isDev()){
     api = 'http://localhost:8000/api/app/';
  }
  else{
     api = 'https://mg.vactive.app/api/app/';
  }
  api = 'https://mg.vactive.app/api/app/';

  //return await axios.post('https://mg.vactive.app/api/app/' + url , data, {
  return await axios.post( api + url , data, {

  headers: {
    'Authorization': `Bearer ${localStorage.getItem('token')}`
  }})
  .then(function (response) {


 H1.notfy_dismiss();
  

  //ld.resolve();
 // ld.bind(true)

  // if(response.data.status === "error" && response.data.code == 204 ){
  
  //   return H1.alert_confirm('info',"بروزرسانی اپلیکیشن!", response.data.message).then(function (res) {
  //     window.location.reload(true);

  //  });

  //  }



     if(response.data.status === "error" && response.data.code == 403 ){

        H1.notfy_error(response.data.message);
        localStorage.clear();
        setTimeout(() => {  return window.location.reload() }, 1000);
    
    }



    else if( response.data.code == 500){


      throw response.data.message;  
      
    }

    
    else{

      if(response.data.data){
        response.data.data = JSON.parse( base64.decode(response.data.data) );

 
       if(H1.isDev()){
        console.log( response.data);
       }
       
      

      }

      if(response.data.status === "error"){
        H1.notfy_error(response.data.message);
     
      }

      else if(response.data.status === "valid"){

        response.data.data.map((item, index) => [

          H1.notfy_error(item)

        ])

      }

      else{
        return response.data;
      }


     // throw response 
    }

    
  })
  .catch(function (error) {
    H1.notfy_dismiss();
    H1.notfy_error("یک مشکل فنی پیش آمده است");
    //console.error(error);
    console.log( error);

    throw null;

    
  });

 
}